import View from "../../../assets/js/view";
import { css } from "../../../assets/js/utils";
import { breakpoints } from "../../../assets/js/config";
import radio from "../../../assets/js/radio";

export default class Nav extends View {
  el = "#nav";

  ui = {
    mobileMenuToggle: ".js-mobileMenuToggle",
    menu: ".js-menu[0]",
    menuItemArrows: ".js-menuItemArrow",
    searchIcon: "#header-search-icon svg",
    search: "#header-search",
    links: "a",
    headerSearchInput: ".js-headerSearchIconInput[0]",
    form: ".js-headerSearchIconForm[0]",
  };

  events = {
    "click @ui.mobileMenuToggle": "handleMobileMenuToggleClick",
    "click @ui.menuItemArrows": "handleMenuItemArrowClick",
    "click @ui.searchIcon": "handleSearchIconClick",
    "click @ui.links": "close",
    "submit @ui.form": "handleSearchSubmit",
    "submit @ui.search": "handleSearchSubmit",
  };

  /* Custom variables */
  isOpen = false;

  init() {
    this.bind("isClickingInside", "close");

    // radio.on('animateout', this.close);
  }

  handleMobileMenuToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.el.classList.add("is-active");
    this.isOpen = true;

    window.addEventListener("click", this.isClickingInside, false);
  }

  close() {
    this.el.classList.remove("is-active");
    this.isOpen = false;
  }

  isClickingInside(e) {
    if (e.target.isEqualNode(this.el) || e.target.closest("#nav")) {
      // Click inside menu
    } else {
      this.close();
      window.removeEventListener("click", this.isClickingInside);
    }
  }

  handleMenuItemArrowClick(e) {
    if (window.innerWidth < breakpoints.small) {
      e.preventDefault();
      e.currentTarget.parentElement.parentElement.classList.toggle("is-open");
    }
  }

  handleSearchIconClick(e) {
    e.preventDefault();

    if (window.innerWidth < breakpoints.small) {
      this.search(this.ui.headerSearchInput.value);
      this.close();
    } else {
      document.body.classList.toggle("search-is-open");
    }
  }

  handleSearchSubmit(e) {
    e.preventDefault();
    this.search(e.currentTarget.elements["header-search-input"].value);
    this.close();
  }

  search(value) {
    window.app.router.fetchPage(`/?s=${value}`);
  }
}
